App.controller('HealthPzuwVisitCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', function ($scope, $sce, $state, $http, packageService, $stateParams) {
    $scope.stateParams = $stateParams;

    $scope.page = 'healthInsurancePzuw_visit';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Umawianie wizyt';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.health.start';
    $scope.$emit('link', $scope.link);

    setTimeout(function () {
        window.location.href = "/";
    }, 1);
}]);
